import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { LkpBanksModel } from '../models/LkpBanksModel';
@Injectable({
  providedIn: 'root'
})
export class LkpBanksService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }

  public getBank(bnkCode : string,comCode: string) {
    let params = new HttpParams();
    params = params.append("compCode", comCode);
    params = params.append("BnkCode", bnkCode);

    const options = {
      params: params
    };
    return this.http.get<LkpBanksModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpBanks/GetBanks', options);
  }

  public AddBank(bank: LkpBanksModel) {
    return this.http.post<LkpBanksModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpBanks/AddBanks', bank);
  }

  public DelBank(bnkCode: string,compCode: string) {

    let params = new HttpParams();

    params = params.append("BnkCode", bnkCode);
    params = params.append("compcode", compCode);
    const options = {
      params: params
    };
    return this.http.delete<LkpBanksModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpBanks/DeleteBanks', options);
  }
  public getBankLookupTop(compCode: string) {

    let params = new HttpParams();
    params = params.append("compcode", compCode);
    const options = {
      params: params
    };

    return this.http.get<LkpBanksModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/LkpBanks/BanksLookupTop', options);
  }
  public getBankDefulte(comCode: string) {
    let params = new HttpParams();
    //curCode

    params = params.append("compcode", comCode);
    const options = {
      params: params
    };
    return this.http.get<LkpBanksModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpBanks/GetBankDefulte', options);
  }
}
